module.exports = __webpack_public_path__ + "static/img/ES.999632b1.svg";